module.exports = __webpack_public_path__ + "static/Hirafi-Algerian-artisans-in-all-thier-glory-21c687a002e86d87bba1b22ca0dd0c48.mp4";